import es from '../../resources/locales/es-ES.json';
export default {
  ...es,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['es-ES'],
};
